import { useMemo } from 'react';

import useQuery from 'hooks/useQuery';
import useSearchWords from 'hooks/useSearchWords';

export interface CompanyLifecyclePropsHook {
  searchWords?: string[];
  lifecycle: string;
}

export default function useCompanyLifecycleProps(
  initialCompanyLifecycle: string,
): CompanyLifecyclePropsHook {
  const [query] = useQuery('companies');
  const searchWords = useSearchWords(query);

  const lifecycle = useMemo(
    () => initialCompanyLifecycle?.replace(/_/g, ' ')?.toUpperCase(),
    [initialCompanyLifecycle],
  );

  return {
    searchWords,
    lifecycle,
  };
}
